import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron left.svg` */
export const ChevronLeftIcon = createTripletGlyphIcon('ChevronLeftIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7283 2.4758C11.028 2.23196 11.4686 2.27697 11.7127 2.57639C11.9566 2.87609 11.9117 3.31762 11.6121 3.56174L5.96271 8.16428L11.5926 12.424C11.9006 12.6574 11.9615 13.0963 11.7283 13.4045C11.4951 13.7125 11.0561 13.7732 10.7479 13.5403L4.49982 8.81272C4.09118 8.50353 4.08019 7.89331 4.47736 7.56955L10.7283 2.4758Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0931 2.8528C12.3927 2.6091 12.8333 2.65402 13.0774 2.95339C13.3214 3.25304 13.2763 3.69457 12.9769 3.93874L6.53447 9.18678L12.9573 14.0462C13.2653 14.2794 13.3261 14.7184 13.0931 15.0266C12.8599 15.3348 12.4209 15.3954 12.1126 15.1624L5.0833 9.84401C4.66879 9.53035 4.65786 8.91163 5.06084 8.58327L12.0931 2.8528Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1869 3.82991C16.5721 3.51604 17.1395 3.57382 17.4535 3.95882C17.7673 4.34403 17.7096 4.91042 17.3246 5.22444L13.0131 8.73714L8.70155 12.2498L17.2992 18.7547C17.6953 19.0547 17.7737 19.6192 17.474 20.0155C17.1742 20.4117 16.6096 20.4897 16.2133 20.1903L6.84022 13.0985C6.30525 12.6932 6.29065 11.8936 6.81093 11.4696L16.1869 3.82991Z"
        fill="currentColor"
      />
    </svg>
  ),
});
